import usePosOrderCurrentAction from "@/shared/atoms/usePosOrderCurrentAction";
import usePosOrderTable from "@/shared/atoms/usePosOrderTable";
import useRestaurantAllTables from "@/shared/queries/restaurantMap/useRestaurantAllTables";
import usePosOrderDeliveryMethod from "@/shared/atoms/usePosOrderDeliveryMethodAtom";
import usePosSettingsHook from "@/shared/hooks/usePosSettingsHook";
import usePosOrderStandardHook from "@/shared/hooks/usePosOrderStandardHook";
import { DeliveryMethods } from "@/shared/utils/enum";
import useActionClick from "./useActionClick";
import PosMenuBottomActionButton, {
  PosMenuAction,
} from "../PosMenu/PosMenuBottomActionButton";
import { useTranslation } from "react-i18next";
import { CurrentActionTypes } from "@/shared/atoms/usePosOrderCurrentAction";

const useEnterTableNumberAction = (): PosMenuAction => {
  const { t } = useTranslation();
  const { data: allTables } = useRestaurantAllTables();
  const [table, setTable] = usePosOrderTable();
  const [deliveryMethod, setDeliveryMethod] = usePosOrderDeliveryMethod();
  const { settings } = usePosSettingsHook();
  const { setStandardPaymentMethod } = usePosOrderStandardHook();

  return {
    name: "enterTableNumber" as CurrentActionTypes,
    label: t("posOrders.table"),
    set: (tableNumber: string) => {
      const found = allTables?.find(
        (t) => t.table_number === parseInt(tableNumber),
      );
      if (found) {
        setDeliveryMethod(DeliveryMethods.DINE_IN);
        setStandardPaymentMethod(DeliveryMethods.DINE_IN);
        setTable(found);
      }
    },
    instantSet: false,
    filtered:
      Boolean(
        settings.delivery_method_options?.includes(DeliveryMethods.DINE_IN),
      ) === false,
    disabled: deliveryMethod === DeliveryMethods.DINE_IN && Boolean(table),
    iconVariant:"table",
  };
};

const EnterTableNumberAction = () => {
  const [currentAction] = usePosOrderCurrentAction();
  const action = useEnterTableNumberAction();
  const handleClick = useActionClick(action);
  
  return (
    <PosMenuBottomActionButton
      action={action}
      isSelected={currentAction?.name === action.name}
      onClick={handleClick}
    />
  );
};

export default EnterTableNumberAction;
